import { useTranslation } from "react-i18next";
import { MiniPlanCard } from "../../components/PlanCard";
import FieldBlock from "../../components/CreateClaim/FieldBlock";
import { RootState } from "../../store/root-reducer";
import { connect } from "react-redux";

function ReviewClaim({ claim }) {
  const { claim_items: claimItems = [], plan = {} } = claim;
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <MiniPlanCard plan={plan} />
      {claimItems.map((item, idx) => (
        <div key={item.id}>
          <div className="bg-[#EBEEEF] min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
            <span className="size-5 flex justify-center items-center  bg-white rounded-full p-3">
              {idx + 1}
            </span>
            <div className="text-black font-semibold  block">
              {item?.type?.name || item?.name || ""}
            </div>
          </div>
          <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
            <FieldBlock label="Manufacturer" value={item?.manufacturer.name} />
            <FieldBlock label="Material" value={item?.material.name} />
            <FieldBlock label="Color" value={item?.color.name} />
            <FieldBlock label="Vendor" value={item?.warrantyItem?.vendor} />
          </div>
          <div className="space-y-3">
            {item.damages?.map((damage, idx) => (
              <div
                className="border-l-4 border-l-[#2D6CCA] ps-2"
                key={damage?.id}
              >
                <div className="text-black font-semibold overflow-hidden">
                  {t("Damage")} {idx + 1}
                </div>
                <div className="space-y-1 divide-y">
                  <FieldBlock
                    label="Damage Category"
                    value={damage?.damageCategory.name}
                  />
                  <FieldBlock
                    label="Specific Damage"
                    value={damage?.specificDamage.name}
                  />
                  <FieldBlock
                    label="Damage Area"
                    value={damage?.specificLocation.name}
                  />
                  <FieldBlock
                    label="When did you notice the damage"
                    value={damage?.damageDate}
                    date
                  />
                  <FieldBlock
                    label="How did it happen"
                    value={damage?.occuredReason.name}
                  />
                  <FieldBlock
                    label="Did you take any steps to remedy"
                    value={damage?.actionTaken.name}
                  />
                  <FieldBlock label="Note" value={damage?.notes} />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  claim: state?.claim || {},
});

export default connect(mapStateToProps)(ReviewClaim);
